import { useRoute, useRouter } from "vue-router";
import { onMounted, getCurrentInstance, reactive } from "vue";
export default {
  name: "Evaluate",
  setup() {
    const router = useRouter();
    const route = useRoute();
    const internal = getCurrentInstance();
    const globalProperties = internal?.appContext.config.globalProperties;
    const data = reactive({
      comps: [{
        label: "收到评价",
        name: "ReceiveEvaluation"
      }, {
        label: "已评价",
        name: "AnnounceEvaluation"
      }, {
        label: "待评价",
        name: "WaitEvaluation"
      }]
    });
    onMounted(() => {});
    return {
      data
    };
  }
};